import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhLocale from './lang/zh';
import enLocale from './lang/en';

Vue.use(VueI18n);

export const LANGUAGE_STORAGE_KEY = 'locale'
export const SUPPORTED_LANGUAGES = ['zh', 'en']
export const DEFAULT_LANGUAGE = 'zh'

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  }
};

export const normalizeLanguage = language => {
  if (SUPPORTED_LANGUAGES.includes(language)) {
    return language
  }
  return DEFAULT_LANGUAGE
}

export const getLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE
  }
  return normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY))
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
  silentTranslationWarn: true
});

export const setLanguage = language => {
  const nextLanguage = normalizeLanguage(language)
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage)
    document.documentElement.setAttribute('lang', nextLanguage === 'zh' ? 'zh' : 'en')
    i18n.locale = nextLanguage
  }
  return nextLanguage
}

export const t = (key, language, fallback = '') => {
  if (language) {
    const nextLanguage = normalizeLanguage(language)
    return messages[nextLanguage][key] || messages[DEFAULT_LANGUAGE][key] || fallback || key
  }
  return i18n.t(key) || fallback || key
}

export const getLanguageText = language => {
  const nextLanguage = normalizeLanguage(language || i18n.locale)
  return messages[nextLanguage].languageText
}

const normalizeMenuLabel = label => String(label || '').replace(/[-&\s/]/g, '')

export const translateMenuLabel = (label, language) => {
  const nextLanguage = normalizeLanguage(language || i18n.locale)
  if (nextLanguage !== 'en') {
    return label
  }
  const normalizedLabel = normalizeMenuLabel(label)
  const menuLabels = enLocale.menuLabels || {}
  return menuLabels[normalizedLabel] || menuLabels[label] || label
}

export default i18n;
